import { CurrencyEnum } from '@systemeio/ui'
import { ListingPhysicalProductInterface } from 'modules/funnels/funnel/components/step-configuration-tab/physical-product-selector/types/listing-physical-product-interface'
import { PRODUCTS_API } from 'modules/products/api/product-api'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useSWR from 'swr'

export function usePhysicalProductsList(currency: CurrencyEnum) {
  const { fetcher } = useFetch<RequestMethodsEnum.get, ListingPhysicalProductInterface[]>({
    method: RequestMethodsEnum.get,
  })

  const { data: physicalProductsList, isLoading } = useSWR(() => {
    return `${PRODUCTS_API}/list-by-currency/${currency}`
  }, fetcher)

  return { physicalProductsList, isLoading }
}
